import React, { Component } from "react";
import Select from "react-select";

// const customStyles = {
//   option: (base, state) => ({
//     ...base,
//     borderBottom: "1px dotted pink"
//   }),
//   control: () => ({
//     width: 200
//   }),
//   singleValue: (base, state) => {
//     const opacity = state.isDisabled ? 0.5 : 1;
//     const transition = "opacity 300ms";

//     return { ...base, opacity, transition };
//   }
// };

class SelectEditorProducts extends Component {
  state = {
    value: this.props.value || {},
  };

  isPopup() {
    return true;
  }

  getValue() {
    console.debug(this.state.value);
    return this.state.value;
  }

  handleChangeInSelect = value => {
    // console.debug(value);
    if (this.props.fromPopup) {
      this.props.returnValue(value);
    } else {
      this.setState({ value });
    }
  };

  render() {
    console.debug(this.props);
    console.debug(this.state);
    return (
      <Select
        options={this.props.values}
        defaultValue={this.state.value}
        onChange={value => this.handleChangeInSelect(value)}
      />
    );
  }
}

export default SelectEditorProducts;



// WEBPACK FOOTER //
// ./src/components/cell-editors/SelectEditorProducts.js